<template>
  <header
    qaid="project-one-right-rail-header"
    class="project-one-right-rail__header flex items-center justify-center relative px-2 lg:px-4 py-4"
  >
    <trek-button
      v-if="isBackButtonEnabled"
      qaid="project-one-right-rail-header-back-button"
      tertiary
      icon-only
      :aria-label="bp('navigationBack')"
      icon="arrow_back"
      class="absolute left-0 lg:left-4"
      @click="$emit('on-backpress')"
    />
    <h3
      qaid="project-one-right-rail-header-title"
      class="font-heading text-lg text-center flex-grow"
      v-html="headerText"
    />
  </header>
</template>

<script>
import TrekButton from '@/components/TrekButton.vue';
import {mapState} from 'vuex';

export default {
  components: {TrekButton},

  props: {
    groupId: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: null,
    },
    isBackButtonEnabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    headerText() {
      return this.title ?? this.activeModuleGroupDescription;
    },

    activeModuleGroupDescription() {
      if (this.groupId && Array.isArray(this.moduleGroups)) {
        const activeModuleGroup = this.moduleGroups.find((group) => group.id === this.groupId);

        return activeModuleGroup?.description;
      }

      return null;
    },

    ...mapState('projectOne', ['moduleGroups']),
  },
};
</script>
